import {
    createContext,
    useState,
    useEffect,
    useContext,
} from '@wordpress/element';
import axios from 'axios';




const is_blocked = function ($node) {
    return $node.is('.processing') || $node.parents('.processing').length;
};

const block = function ($node) {
    if (!is_blocked($node)) {
        $node.addClass('processing').block({
            message: null,
            overlayCSS: {
                background: '#fff',
                opacity: 0.6,
            },
        });
    }
};

const unblock = function ($node) {
    $node.removeClass('processing').unblock();
};



export const GlobalContext = createContext({});
export const GlobalWrapper = ({ children }) => {

    const api_base_url = 'https://beefapi.beef.org/api/v2'

    //create function to fetch data from api using axios
    const fetchCollections = async (collections) => {

        const url = (collections !== '') ? `${api_base_url}/recipe/collection/list` : `${api_base_url}/recipe/collection`;
        console.log(collections)
        const response = await axios.get(url, {
            withCredentials: false,
            params: {

                'AuthorizationAppID': uss_settings.beef_authorization_app_id,
                'AuthorizationAppKey': uss_settings.beef_authorization_app_key,
                'collectionIDList': collections
            }
        });
        const data = await response.data;
        return data.collectionListing;
    };

    const fetchRecipesFromCollection = async (props) => {
        const { collection_id } = props;
        const url = collection_id ? `${api_base_url}/recipe/collection/${collection_id}` : false;
        if (url) {
            const response = await axios.get(url, {
                withCredentials: false,
                params: {

                    'AuthorizationAppID': uss_settings.beef_authorization_app_id,
                    'AuthorizationAppKey': uss_settings.beef_authorization_app_key
                }
            });
            const data = await response.data;
            console.log(data)
            const image = 'https://' + data.media[0].links[0].href
            return { recipes: data.recipes, title: data.collectionName, description: data.description, image };
        }
    };

    const fetchRecipe = async (props) => {
        const { recipe_id } = props;
        const url = recipe_id ? `${api_base_url}/recipe/${recipe_id}` : false;
        if (url) {
            const response = await axios.get(url, {
                withCredentials: false,
                params: {
                    'AuthorizationAppID': uss_settings.beef_authorization_app_id,
                    'AuthorizationAppKey': uss_settings.beef_authorization_app_key
                }
            });
            const data = await response.data;
            return data;
        }
    };



    const ourContext = {
        fetchCollections,
        fetchRecipesFromCollection,
        fetchRecipe
    };
    return (
        <GlobalContext.Provider value={ourContext}>
            {children}
        </GlobalContext.Provider>
    );
};
export const useGlobalState = () => useContext(GlobalContext);
